<div [hidden]="!message" class="alert-{{type}} w-470" role="alert" #alertNotice>
	<div [innerHTML]="message"></div>
</div>
